import { Table, TableBody, TableHeader } from '@library/components/table';
import { Loading } from '@library/components/Loading';
import { MemberWithdrawalsTableRow } from '@bo-components/members/memberWithdrawals';
import { NoResults } from '@library/components/NoResults';
import type { Withdrawal } from '@library/types/payments';
import { getMemberPaymentsTableHeaders } from '@bo-utils/members/memberPayments';
import { useMemo } from 'react';

export interface MemberWithdrawalsTableProps {
  isLoading: boolean;
  onRowClick: (id: string) => void;
  withdrawals: Array<Withdrawal>;
}

export const MemberWithdrawalsTable = ({
  isLoading,
  onRowClick,
  withdrawals
}: MemberWithdrawalsTableProps) => {
  const withdrawalTableHeaders = useMemo(
    () => getMemberPaymentsTableHeaders('withdrawal'),
    []
  );

  const handleRowClick = (id: string) => {
    onRowClick(id);
  };

  if (isLoading) {
    return <Loading loadingMessage="Loading Withdrawals" />;
  }

  if (!withdrawals?.length) {
    return (
      <NoResults
        className="m-0 w-full"
        dataTestId="no-member-withdrawals-results"
        label="Use the search fields, dropdowns, or reset filters to find withdrawals"
      />
    );
  }

  return (
    <Table>
      <div
        className="flex flex-col overflow-x-auto"
        data-testid="members-search-results"
      >
        <TableHeader headers={withdrawalTableHeaders} />
        <TableBody>
          {withdrawals.map((withdrawal) => (
            <MemberWithdrawalsTableRow
              key={withdrawal.merchantReferenceId}
              withdrawal={withdrawal}
              onRowClick={handleRowClick}
            />
          ))}
        </TableBody>
      </div>
    </Table>
  );
};
